const headerMessages = {
  init() {
    // Desktop and mobile each render their own ticker, so match by class:
    // vTicker runs per element via this.each().
    $(".js-news-flash").vTicker({
      speed: 500,
      pause: 3000,
      animation: "fade",
      mousePause: false,
      showItems: 1,
    });
  },
};

const headerSearch = {
  init() {
    this.bindSearchInput();
    this.handleLiveSearch();
  },

  bindSearchInput() {
    let searchTimeout = null;
    $(".input-search-product")
      .on("focus", function () {
        $form = $(this).closest("form");
        $form.find(".spinner-icon").show();
        $.ajax({
          type: "GET",
          url: $form.data("ajax-url"),
          data: $form.serialize(),
          success: (res) => {
            if (!res.error && res.data !== "") {
              $form.find(".form-search-result").html(res.data).addClass("active");
            } else {
              $form.find(".form-search-result").html("").removeClass("active");
            }
            RecentSearch.bindEvents();
            $form.find(".form-search-result").addClass("active");
            $form.find(".spinner-icon").hide();
          },
          error: () => {
            $form.find(".spinner-icon").hide();
          },
        });
      })
      .on("keydown", function () {
        $(this).closest("form").find(".form-search-result").html("").removeClass("active");
      })
      .on("keyup", function () {
        const $form = $(this).closest("form");
        $form.find(".spinner-icon").show();
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function () {
          $.ajax({
            type: "GET",
            url: $form.data("ajax-url"),
            data: $form.serialize(),
            success: (res) => {
              if (!res.error && res.data !== "") {
                $form.find(".form-search-result").html(res.data).addClass("active");
              } else {
                $form.find(".form-search-result").html("").removeClass("active");
              }
              RecentSearch.bindEvents();

              $form.find(".spinner-icon").hide();
            },
            error: () => {
              $form.find(".spinner-icon").hide();
            },
          });
        }, 500);
      });
  },

  handleLiveSearch() {
    $("body").on("click", function (e) {
      if (!$(e.target).closest(".form-search").length) {
        $(".form-search-result").removeClass("active");
        $('input[name="q"]').not('[data-handle-live-search="false"]').val("");
      }
    });

    $(".form-search").on("click", (e) => {
      e.stopPropagation();
    });

    $(".form-search > form").on("submit", (e) => {
      const keyword = $('input[name="q"]').val().trim();
      RecentSearch.saveRecentSearch(keyword);
    });
  },
};

const headerMobile = {
  init() {
    this.sticky();
    this.siteToggleAction();
    this.subMenuToggle();
  },

  sticky() {
    let header = $(".header-area, .header__mobile"),
      checkpoint = 50;
    header.each(function () {
      let el = $(this);
      $(window).scroll(function () {
        let currentPosition = $(this).scrollTop();
        if (currentPosition > checkpoint) {
          if (el.hasClass("header-area")) {
            const headerBottom = el.find(".header-bottom");

            if (headerBottom.length && !headerBottom.hasClass("no-sticky")) {
              headerBottom.addClass("header-sticky");
            }
          } else {
            if (!el.hasClass("no-sticky")) {
              el.addClass("header-sticky");
            }
          }
        } else {
          if (el.hasClass("header-area")) {
            const headerBottom = el.find(".header-bottom");
            if (headerBottom.length && !headerBottom.hasClass("no-sticky")) {
              headerBottom.removeClass("header-sticky");
            }
          } else {
            if (!el.hasClass("no-sticky")) {
              el.removeClass("header-sticky");
            }
          }
        }
      });
    });
  },

  siteToggleAction() {
    $(".ps-toggle--sidebar").on("click", function (e) {
      e.preventDefault();
      let url = $(this).attr("href");
      $(this).toggleClass("active");
      $(this).siblings("a").removeClass("active");
      $(url).toggleClass("active");
      $(url).siblings(".ps-panel--sidebar").removeClass("active");
      if ($(this).hasClass("active")) {
        $(".ps-site-overlay").addClass("active");
        $("body").css("overflow", "hidden");
      } else {
        $(".ps-site-overlay").removeClass("active");
        $("body").css("overflow", "");
      }
    });

    $("body").on("click", function (e) {
      if ($(e.target).siblings(".ps-panel--sidebar").hasClass("active")) {
        $("body").css("overflow", "");
        $(".ps-toggle--sidebar").removeClass("active");
        $(".ps-panel--sidebar").removeClass("active");
        $(".ps-site-overlay").removeClass("active");
      }
    });

    $(".js-close-mobile-panel").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $("body").css("overflow", "");
      $(".ps-toggle--sidebar").removeClass("active");
      $(".ps-panel--sidebar").removeClass("active");
      $(".ps-site-overlay").removeClass("active");
    });
  },

  subMenuToggle() {
    $(".panel .menu-item-has-children > .sub-toggle").on("click", function (e) {
      e.preventDefault();
      let current = $(this).parent(".menu-item-has-children");
      $(this).toggleClass("active");
      current.siblings().find(".sub-toggle").removeClass("active");
      current.children(".sub-menu").slideToggle(350);
      current.siblings().find(".sub-menu").slideUp(350);
    });
  },
};

$(function () {
  headerMessages.init();
  headerMobile.init();
});

$(document).ready(function () {
  headerSearch.init();
});
